<template>
    <div>
        <div class="spacer"></div>
        <h3 class="text-center h4">Encontrá toda la información que necesitas</h3>
        <div class="row">

            <div class="col-12 col-lg-3 col-md-6 col-sm-6 p-3" v-for="(item, index) in QuicksAccess" :key="index">
                <RouterLink :to="{name: item.to}" class="text-dark text-decoration-none bg-light card text-center pointer">
                    <div class="card-body card-quick-access">
                        <i class="fa-5x fas mt-3" :class="`fa-${item.icon} text-${!(index % 2) ? 'success' : 'danger'}`"></i>
                        <p class="mt-3">{{item.description}} <span class="text-info">{{item.linkText}}</span>
                        </p>
                    </div>
                </RouterLink>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'QuickAcess',
    data(){
        return{
            QuicksAccess: require('@/assets/json/quickAccess')
        }
    }
}
</script>